export const getPushNotificationSupported = () => 'serviceWorker' in navigator && 'PushManager' in window

export const registerServiceWorker = () => navigator.serviceWorker.register('/service-worker.js')

export const askUserPermission = async () => await Notification.requestPermission()

export const getUserSubscription = async () => {
  const serviceWorker = await navigator.serviceWorker.ready
  return await serviceWorker.pushManager.getSubscription()
}

export const urlB64ToUint8Array = (base64String: string = '') => {
  const padding = '='.repeat((4 - (base64String.length % 4)) % 4)
  const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/')
  const rawData = window.atob(base64)
  const outputArray = new Uint8Array(rawData.length)
  for (let i = 0; i < rawData.length; ++i) {
    outputArray[i] = rawData.charCodeAt(i)
  }
  return outputArray
}

export const createNotificationSubscription = async () => {
  const serviceWorker = await navigator.serviceWorker.ready

  return await serviceWorker.pushManager.subscribe({
    userVisibleOnly: true,
    applicationServerKey: urlB64ToUint8Array(process.env.REACT_APP_WEB_PUSH_PUBLIC_KEY as string)
  })
}
